import { format } from 'date-fns';
import { DateRange, DateRangeType } from './tm-date-range';

export const mapDateRangeToDto = (dateRange?: DateRange, specificRange = true) => {
    if (!dateRange) {
        return {
            operator: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            specificDate: undefined,
        };
    }
    const { startDate, rangeType } = dateRange;
    const dateFrom = startDate ? format(startDate, 'MM/dd/yyyy') : undefined;
    const rangeValue = specificRange ? 'Date Range' : 'Range';
    let operator = '';

    if (rangeType && rangeType !== DateRangeType.None) {
        operator =
            rangeType === DateRangeType.SpecificDate || rangeType === DateRangeType.Today
                ? 'Specific Date'
                : rangeValue;
    }

    return {
        operator,
        dateFrom,
        dateTo: dateRange.endDate ? format(dateRange.endDate, 'MM/dd/yyyy') : undefined,
        specificDate:
            dateRange.rangeType === DateRangeType.SpecificDate ||
            dateRange.rangeType === DateRangeType.Today
                ? dateFrom
                : undefined,
    };
};
